import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { OrgAssociateCentersProvider } from 'src/hooks/useOrgAssociates';
import { UserDetailsPage } from '../';
import AddUserPage from '../AddUserPage';
import routes from '../routes';
import MyOrganisationPage from './MyOrganisationPage';

const MyOrganisationPageWithAssociateContext: React.FC = () => {
  return (
    <OrgAssociateCentersProvider>
      <MyOrganisationPage />
    </OrgAssociateCentersProvider>
  );
};

const AddUserPageWithAssociateContext: React.FC = () => {
  return (
    <OrgAssociateCentersProvider>
      <AddUserPage />
    </OrgAssociateCentersProvider>
  );
};

const UserDetailsPageWithAssociateContext: React.FC = () => {
  return (
    <OrgAssociateCentersProvider>
      <UserDetailsPage />
    </OrgAssociateCentersProvider>
  );
};

const MyOrganisationEntry: React.FC = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${match.url}/users/add`}
        exact
        component={AddUserPageWithAssociateContext}
      />
      <Route
        path={`${match.url}/associate/child/:associateId/users/add`}
        exact
        component={AddUserPageWithAssociateContext}
      />
      <Route
        path={`${match.url}/users/:UID`}
        exact
        component={UserDetailsPage}
      />
      <Route
        path={`${match.url}/admins/:UID`}
        exact
        component={UserDetailsPage}
      />
      <Route
        path={`${match.url}/associate/child/:associateId/users/:UID`}
        exact
        component={UserDetailsPageWithAssociateContext}
      />
      <Route
        path={`${match.url}/users/associate/child/:associateId/users/:UID`}
        exact
        component={UserDetailsPageWithAssociateContext}
      />
      <Route
        path={`${match.url}/admins/associate/child/:associateId/admin/:UID`}
        exact
        component={UserDetailsPageWithAssociateContext}
      />
      <Route
        path={`${match.url}/associate/child/:associateId`}
        exact
        component={MyOrganisationPageWithAssociateContext}
      />
      <Route
        path={routes.MyOrganisation.path}
        exact
        component={MyOrganisationPageWithAssociateContext}
      />
      {/* <Route path={`${match.url}`}>
        <Redirect to="/organisation" />
      </Route> */}
    </Switch>
  );
};

export default MyOrganisationEntry;
